var React = require('react');

function No (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4_31)","key":0},[React.createElement("path",{"d":"M4 4L20 20","stroke":"#FF0000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4 20L20 4","stroke":"#FF0000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4_31"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

No.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = No;

No.default = No;
